import { defineMessages } from 'react-intl-next';
export var messages = defineMessages({
  searchPlaceholder: {
    id: 'csm.chat.widget.search.trigger.search.placeholder',
    defaultMessage: 'Ask anything',
    description: 'placeholder for the CSM chat widget search trigger input'
  },
  searchFieldDescription: {
    id: 'csm.chat.widget.search.trigger.search.field.description',
    defaultMessage: 'Submit your question to get chat with and get answers from our AI assistant',
    description: 'Describes that the input field upon submission will trigger the chat widget'
  },
  searchInputLabel: {
    id: 'csm.chat.widget.search.trigger.search.input.label',
    defaultMessage: 'Chat search trigger input',
    description: 'Accessibility label for chat search input'
  }
});